export const TOGGLE_FAVORITE_PLAN = "favorite_plans/TOGGLE_FAVORITE_PLAN";

export function favoritePlan({ planID, location }) {
  return {
    type: TOGGLE_FAVORITE_PLAN,
    planID,
    meta: {
      analytics: {
        type: "plan_added_to_favorites",
        properties: {
          plan_id: planID,
          location,
        },
      },
    },
  };
}
